import { Match, Switch } from "solid-js";
import type { Status } from "../api/tickets";

export function StatusIcon(props: { status: Status; size?: number }) {
  const s = () => props.size ?? 14;
  return (
    <svg
      width={s()}
      height={s()}
      viewBox="0 0 14 14"
      style={{ "flex-shrink": 0 }}
    >
      <Switch>
        <Match when={props.status === "backlog"}>
          <circle
            cx="7"
            cy="7"
            r="6"
            fill="none"
            stroke="var(--c-status-backlog)"
            stroke-width="1.2"
            stroke-dasharray="2.5 2"
          />
        </Match>
        <Match when={props.status === "todo"}>
          <circle
            cx="7"
            cy="7"
            r="6"
            fill="none"
            stroke="var(--c-status-todo)"
            stroke-width="1.5"
          />
        </Match>
        <Match when={props.status === "doing"}>
          <circle
            cx="7"
            cy="7"
            r="6"
            fill="none"
            stroke="var(--c-status-doing)"
            stroke-width="1.5"
          />
          <path
            d="M 7 7 L 7 1 A 6 6 0 0 1 13 7 Z"
            fill="var(--c-status-doing)"
          />
        </Match>
        <Match when={props.status === "blocked"}>
          <circle cx="7" cy="7" r="6" fill="var(--c-status-blocked)" />
          <path
            d="M 4.5 4.5 L 9.5 9.5 M 9.5 4.5 L 4.5 9.5"
            stroke="white"
            stroke-width="1.4"
            stroke-linecap="round"
          />
        </Match>
        <Match when={props.status === "done"}>
          <circle cx="7" cy="7" r="6" fill="var(--c-status-done)" />
          <path
            d="M 4 7 L 6 9 L 10 5"
            fill="none"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </Match>
      </Switch>
    </svg>
  );
}
